<div
  class="cost-card"
  [ngClass]="{ small: (screenSize.size | async) === 'small' }"
>
  @if (icon && iconTheme) {
  <un-icon [type]="icon" [theme]="iconTheme" [size]="26"></un-icon>
  }
  <div
    class="cost"
    [ngClass]="{ small: (screenSize.size | async) === 'small' }"
  >
    @if (unTitle) {
    <span class="t-small title">{{ unTitle }}</span>
    } @if (amount || amount === 0) {
    <span class="amount">
      {{ amount | unCurrency : currency }}@if (interval) {
      <span> {{ interval | unTitleCase | lowercase }}</span>
      }
    </span>
    } @if (max || min) {
    <span class="amount">
      <span> {{ min | unCurrency : currency }}</span>
      @if (max && min) {
      <span>-</span>
      }
      <span> {{ max | unCurrency : currency }}</span>
      @if (interval) {
      <span> {{ interval | unTitleCase | lowercase }}</span>
      }
    </span>
    } @if (!amount && !max && !min && amount !== 0 && max !== 0 && min !== 0) {
    <span> Unknown </span>
    }
  </div>
</div>
